module.exports = __webpack_public_path__ + "static/media/GABA_Post_2018.12.28.569d5c16.webp";